import React, { useState, useEffect, useRef } from "react";
import Burrs1 from "./Images/Burrs1.png";
import Ecmm1 from "./Images/Ecmm1.png";

// ---- JSONBIN.IO SHARED PERSISTENCE ----
// All dropdown Add/Remove lists now live in a single JSONBin "bin" instead
// of localStorage, so when one user adds/removes an option, every other
// user sees it (after the next load/poll) instead of it being stuck in
// that one browser.
//
// SETUP (one-time):
// 1. Create a free account at https://jsonbin.io
// 2. Create a new bin with starting content: {}
// 3. Copy the Bin ID (from the bin's URL/dashboard) and your X-Master-Key
//    from Account -> API Keys, and paste them below - OR set them as
//    environment variables REACT_APP_JSONBIN_BIN_ID and
//    REACT_APP_JSONBIN_API_KEY (e.g. in a .env file) which is safer than
//    hardcoding them here.
const JSONBIN_BIN_ID =
  process.env.REACT_APP_JSONBIN_BIN_ID || "6a916555f5f4af5e294d64c5";
const JSONBIN_API_KEY =
  process.env.REACT_APP_JSONBIN_API_KEY ||
  "$2a$10$q5yFzvEqzU8NYKWFheK9S.lfRU2FwruXXyEdcgjHZZhU.S2mMvjQK";
const JSONBIN_URL = `https://api.jsonbin.io/v3/b/${JSONBIN_BIN_ID}`;

// How often (ms) to re-fetch JSONBin so changes made by other users show
// up in this browser automatically, without needing a manual refresh.
const SYNC_POLL_INTERVAL = 15000;

// Fetch the full shared "all dropdown lists" object from JSONBin.
// Returns null on failure so callers can safely keep using local state.
const fetchAllListsFromBin = async () => {
  try {
    const res = await fetch(`${JSONBIN_URL}/latest`, {
      method: "GET",
      headers: {
        "X-Master-Key": JSONBIN_API_KEY,
      },
    });

    if (!res.ok) throw new Error(`JSONBin GET failed: ${res.status}`);

    const json = await res.json();
    return json.record || {};
  } catch (err) {
    console.error("Error fetching dropdown lists from JSONBin:", err);
    return null;
  }
};

// Push the full shared "all dropdown lists" object to JSONBin, overwriting
// whatever is currently stored there. Every list is sent together in one
// request so that saving one list can never clobber another list that
// another user just changed.
const saveAllListsToBin = async (allLists) => {
  try {
    const res = await fetch(JSONBIN_URL, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "X-Master-Key": JSONBIN_API_KEY,
      },
      body: JSON.stringify(allLists),
    });

    if (!res.ok) throw new Error(`JSONBin PUT failed: ${res.status}`);
  } catch (err) {
    console.error("Error saving dropdown lists to JSONBin:", err);
  }
};

const ShopFloor = () => {
  const data = {
    Person: ["Anandhu", "Sayan", "Ahmed", "Gahana", "Shambhu", "Subashini"],

    Projects: [
      "RR precision",
      "MT Auto",
      "Tafe Bhopal",
     
    ],

    ProjectWorks: [
      "ECM trial",
      "Machine Making",
      "Machine Maintenance",
      "Fixture maintenance",
      "Fixture making",
      "Electrolyte making",
      "ECM Machine Testing",
      "Electrical Wiring",
      "PCB Programming",
      "Routing",
      "Drilling",
      "Tapping",
      "Electrode Machining",
      "Machine Buffing",
      "Machine Cleaning",
      "Machine Welding",
      "Laser Cutting",
      "Machine Sheet Metal Bending",
      "Machine Sheet Metal Cutting",
      "Documentation",
    ],

    Machines: [
      "Routing",
      "Grinding",
      "Buffing",
      "Drilling",
      "Milling",
      "ECM 300",
      "Burrgon",
      "Hand Drilling",
      "Hand Cutting",
      "Laser Welding",
      "Arc Welding",
      "Hydraulic Press",
      "Lathe",
      "Laser Marking",
      "Packing",
      "Laser Wielding Machine",
      "Router",
      "Hand Tap",
      "Milling Machine",
      "Angle Grinder",
      "Table Drilling Machine",
      "Pillar Drilling Machine",
      "Packing Machine",
      "ECM 300",
      "Burrgon",
      "Laser Marking Machine",
      "Circular saw",
      "CNC Turning -GEDEE WEILER",
      "CNC Turning -JYOTI",
      "CNC Turning -PAVAN",
      "Soldering Iron",
      "Hot Air Gun",
      "Hand Power Drill",
      "Arc Welding Machine",
      "Oscilloscope",
      "Chemical filtration equipment",
      "Rolling Machine",
      "ScrewDriver",
      "Allen Key",
    ],

    Shifts: ["1st", "2nd", "3rd", "General"],

    Area: [
      "Cosmos 1",
      "Cosmos 2",
      "Cosmos 3",
      "Cosmos 4",
      "Cosmos 5",
    ],

    Consumed: [
      "Wire",
      "SS Nuts",
      "SS Bolts",
      "Washers",
      "Glue",
      "Insulation Tape",
      "Connecting Pins",
      "Sleeves",
      "PVC Sheet",
      "PP Sheet",
      "Polycarbonate sheet",
      "SS Rod",
      "SS Sheet",
      "Brass Rod",
      "Allen Bolt",
      "SS Screw",
    ],

    WorkStatus: [
      "Started",
      "Take over",
      "Work In Progress",
      "Hand over",
      "Finished",
    ],

    ToolsConsumed: ["1", "2", "3", "4", "5"],

    WFHNames: ["Mamtha", "Jatin Sharma", "Harshit Karmakar"],

    DesignActivities: [
      "Machine and Fixture Design",
      "Purchase Activities",
      "ERP",
      "Installation",
      "Packing",
    ],
  };

  // MACHINE ICONS
  const machineImages = [Burrs1, Ecmm1];

  // MACHINE PICTURES
  const machinePics = [Burrs1, Ecmm1];

  const [form, setForm] = useState({
    person: "",
    project: "",
    work: "",
    machine: "",
    shift_name: "",
    area: "",
    consumed: "",
    toolsConsumed: "",
    status: "",
    workDescription: "",
    startTime: "",
    endTime: "",
    quantity: "",
    rejection: "",
    wfhName: "",
    designActivity: "",
    remarks: "",
  });

  const [botMessage, setBotMessage] = useState(
    "Welcome to Cosmos Automation"
  );

  const [pointer, setPointer] = useState({
    x: 0,
    y: 0,
  });

  useEffect(() => {
    const defaultMessages = [
      "Welcome to Cosmos Automation",
      "Select Person and Project",
      "Track Production Activities",
      "Touch and Move for Smart Feel",
      "Submit Manufacturing Details",
    ];

    let i = 0;

    const interval = setInterval(() => {
      if (form.person) {
        const personMessages = [
          `Hi ${form.person}, Welcome to Cosmos Automation`,
          `${form.person}, Track Production Activities`,
          `${form.person}, Submit Manufacturing Details`,
          `${form.person}, Have a Productive Shift`,
        ];

        i = (i + 1) % personMessages.length;

        setBotMessage(personMessages[i]);
      } else {
        i = (i + 1) % defaultMessages.length;

        setBotMessage(defaultMessages[i]);
      }
    }, 3500);

    return () => clearInterval(interval);
  }, [form.person]);

  const handleMove = (e) => {
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;

    const clientY = e.touches ? e.touches[0].clientY : e.clientY;

    setPointer({
      x: clientX,
      y: clientY,
    });
  };

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
  try {
    const res = await fetch("https://www.d-rosa.ai/SFWRTAPI", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(form),
    });

    const result = await res.json();

    if (res.ok) {
      alert("Data Stored Successfully");

      setForm({
        person: "",
        project: "",
        work: "",
        machine: "",
        shift_name: "",
        area: "",
        consumed: "",
        toolsConsumed: "",
        status: "",
        workDescription: "",
        startTime: "",
        endTime: "",
        quantity: "",
        rejection: "",
        wfhName: "",
        designActivity: "",
        remarks: "",
      });
    } else {
      alert(result.error);
    }
  } catch (err) {
    console.error(err);
    alert("Server Error");
  }
};


// ---- DATE FILTER HELPER ----
// Normalizes any date-like value (ISO string, timestamp, Date object) down
// to a "date only" JS Date (time set to 00:00:00) so that comparisons are
// not affected by the time-of-day portion of "createdAt".
const toDateOnly = (value) => {
  if (!value) return null;

  const d = new Date(value);

  if (isNaN(d.getTime())) return null;

  d.setHours(0, 0, 0, 0);
  return d;
};

// ---- CSV DATE FORMAT HELPER ----
// Reformats a createdAt value for the CSV export only, as "DD-MM-YYYY"
// (date, month, year) - e.g. "2026-08-13 11:54:00" -> "13-08-2026 11:54:00".
// Parses the raw string directly (rather than going through `new Date()`,
// which can shift the date by a day depending on the browser's timezone)
// so the day/month/year printed in the CSV always matches what was stored.
// Only used when building the CSV row values below - the date filtering
// above (toDateOnly) is untouched and keeps comparing real Date objects.
const formatDateForCSV = (value) => {
  if (!value) return "";
  const str = String(value).trim();

  // "YYYY-MM-DD..." (MySQL DATETIME / ISO) - year comes first.
  let m = str.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
  if (m) {
    const [, y, mo, d] = m;
    return reorderToDMY(str, y, mo, d);
  }

  // "DD-MM-YYYY..." - already day/month first, just zero-pad.
  m = str.match(/^(\d{1,2})-(\d{1,2})-(\d{4})/);
  if (m) {
    const [, d, mo, y] = m;
    return reorderToDMY(str, y, mo, d);
  }

  // "DD/MM/YYYY..." - same as above but slash-separated.
  m = str.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
  if (m) {
    const [, d, mo, y] = m;
    return reorderToDMY(str, y, mo, d);
  }

  // Fallback: let the JS Date parser take a shot at anything else.
  const parsed = new Date(str);
  if (!isNaN(parsed.getTime())) {
    const y = parsed.getFullYear();
    const mo = String(parsed.getMonth() + 1).padStart(2, "0");
    const d = String(parsed.getDate()).padStart(2, "0");
    return reorderToDMY(str, y, mo, d);
  }

  // Couldn't parse it at all - leave the original value untouched rather
  // than dropping it from the export.
  return str;
};

// Builds the final "DD-MM-YYYY" (optionally " HH:mm[:ss]") string, keeping
// any time-of-day portion found in the original raw value.
const reorderToDMY = (originalStr, y, mo, d) => {
  const formattedDate = `${String(d).padStart(2, "0")}-${String(mo).padStart(
    2,
    "0"
  )}-${y}`;
  const timeMatch = originalStr.match(/(\d{1,2}:\d{2}(:\d{2})?)/);
  return timeMatch ? `${formattedDate} ${timeMatch[1]}` : formattedDate;
};

// filterOption: "all" | "single" | "range"
// singleDate: "YYYY-MM-DD" (used when filterOption === "single")
// rangeStart / rangeEnd: "YYYY-MM-DD" (used when filterOption === "range")
const downloadCSV = async (
  filterOption = "all",
  singleDate = null,
  rangeStart = null,
  rangeEnd = null
) => {
  try {
    const response = await fetch("https://www.d-rosa.ai/SFGETALLAPI", {
      method: "GET",
    });

    const result = await response.json();

    if (!response.ok || !result.success) {
      alert(result.error || "Failed to fetch data from server.");
      return;
    }

    let allData = result.data || [];

    if (allData.length === 0) {
      alert("No data recorded yet in the database.");
      return;
    }

    // ---- CONDITION 1: single date filter (e.g. only August 11th) ----
    if (filterOption === "single" && singleDate) {
      const target = toDateOnly(singleDate);

      allData = allData.filter((row) => {
        const rowDate = toDateOnly(row.createdAt);
        return rowDate && target && rowDate.getTime() === target.getTime();
      });
    }

    // ---- CONDITION 2: date range filter (e.g. August 10th to August 12th) ----
    else if (filterOption === "range" && rangeStart && rangeEnd) {
      const start = toDateOnly(rangeStart);
      const end = toDateOnly(rangeEnd);

      allData = allData.filter((row) => {
        const rowDate = toDateOnly(row.createdAt);
        return (
          rowDate &&
          start &&
          end &&
          rowDate.getTime() >= start.getTime() &&
          rowDate.getTime() <= end.getTime()
        );
      });
    }

    if (allData.length === 0) {
      alert("No records found for the selected date filter.");
      return;
    }

    // Fixed column order as requested
    const headers = [
      "newPerson",
      "shift_name",
      "project",
      "area",
      "machine",
      "work",
      "status",
      "workDescription",
      "startTime",
      "endTime",
      "toolsConsumed",
      "wfhName",
      "designActivity",
      "consumed",
      "quantity",
      "rejection",
      "remarks",
      "createdAt",
    ];

    const csvRows = [];
    csvRows.push(headers.join(","));

    allData.forEach((row) => {
      const values = headers.map((header) => {
        // Store the createdAt date as date,month,year (DD-MM-YYYY) in the
        // CSV, regardless of whatever order/format the backend sent it in.
        const value =
          header === "createdAt"
            ? formatDateForCSV(row[header])
            : row[header];
        return `"${value !== undefined && value !== null ? value : ""}"`;
      });
      csvRows.push(values.join(","));
    });

    const csvContent = csvRows.join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);

    // Build a descriptive filename based on the filter that was applied
    let fileName = "Shopfloor_AllEmployees.csv";

    if (filterOption === "single" && singleDate) {
      fileName = `Shopfloor_${singleDate}.csv`;
    } else if (filterOption === "range" && rangeStart && rangeEnd) {
      fileName = `Shopfloor_${rangeStart}_to_${rangeEnd}.csv`;
    }

    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error(error);
    alert("Server Error while fetching data for download.");
  }
};

// --- Access control: Download CSV is restricted to Team Leader / HR ---
const TEAM_LEADER_HR_PIN = "2580";

// --- Access control: Add/Remove on any dropdown list is restricted to
// Team Leader / HR. Every Add/Remove button calls this first; if the PIN
// is missing or wrong, the action is blocked and the list is left untouched.
const verifyHRAccess = () => {
  const enteredPin = window.prompt(
    "Adding or removing dropdown options is restricted to Team Leader / HR.\nEnter the access PIN to continue:"
  );

  if (enteredPin === null) return false;

  if (enteredPin.trim() !== TEAM_LEADER_HR_PIN) {
    alert("Access Denied: Only Team Leader / HR can add or remove dropdown options.");
    return false;
  }

  return true;
};

const handleDownloadClick = () => {
  const enteredPin = window.prompt(
    "This report is restricted to Team Leader / HR.\nEnter the access PIN to continue:"
  );

  if (enteredPin === null) return;

  if (enteredPin.trim() !== TEAM_LEADER_HR_PIN) {
    alert("Access Denied: Only Team Leader / HR can download this report.");
    return;
  }

  // ---- Ask which date filter to apply before downloading ----
  const filterChoice = window.prompt(
    "Choose CSV filter:\n" +
      "1 = All records\n" +
      "2 = Single date (e.g. 2026-08-11)\n" +
      "3 = Date range (e.g. 2026-08-10 to 2026-08-12)\n\n" +
      "Enter 1, 2, or 3:"
  );

  if (filterChoice === null) return;

  const choice = filterChoice.trim();

  if (choice === "2") {
    // CONDITION 1: single date, e.g. only August 11th
    const singleDate = window.prompt(
      "Enter the date to filter (YYYY-MM-DD), e.g. 2026-08-11:"
    );

    if (!singleDate) return;

    downloadCSV("single", singleDate.trim());
  } else if (choice === "3") {
    // CONDITION 2: date range, e.g. August 10th to August 12th
    const rangeStart = window.prompt(
      "Enter start date (YYYY-MM-DD), e.g. 2026-08-10:"
    );

    if (!rangeStart) return;

    const rangeEnd = window.prompt(
      "Enter end date (YYYY-MM-DD), e.g. 2026-08-12:"
    );

    if (!rangeEnd) return;

    downloadCSV("range", null, rangeStart.trim(), rangeEnd.trim());
  } else {
    downloadCSV("all");
  }
};



  const [persons, setPersons] = useState(data.Person);
  const [selectedPerson, setSelectedPerson] = useState("");
  const [newPerson, setNewPerson] = useState("");

  // Add Person
  const handleAddPerson = () => {
  if (!verifyHRAccess()) return;

  const name = newPerson.trim();

  if (!name) {
    alert("Enter a person name");
    return;
  }

  if (persons.includes(name)) {
    alert("Person already exists");
    return;
  }

  const updatedPersons = [...persons, name];

  setPersons(updatedPersons);

  setForm((prev) => ({
    ...prev,
    person: name,
  }));

  setSelectedPerson(name);
  setNewPerson("");
};

  // Delete Selected Person
  const handleDeletePerson = () => {
  if (!verifyHRAccess()) return;

  if (!selectedPerson) {
    alert("Select a person to delete");
    return;
  }

  const updatedPersons = persons.filter(
    (person) => person !== selectedPerson
  );

  setPersons(updatedPersons);

  if (form.person === selectedPerson) {
    setForm((prev) => ({
      ...prev,
      person: "",
    }));
  }

  setSelectedPerson("");
};



 const [projects, setProjects] = useState(data.Projects);
  const [newProject, setNewProject] = useState("");

  // ADD project
  const addProject = () => {
    if (!verifyHRAccess()) return;

    const value = newProject.trim();

    if (value === "") {
      alert("Enter project name");
      return;
    }

    if (projects.includes(value)) {
      alert("Project already exists");
      return;
    }

    setProjects([...projects, value]);
    setNewProject("");
  };

  // DELETE selected project
  const deleteProject = () => {
    if (!verifyHRAccess()) return;

    if (!form.project) {
      alert("Select a project to delete");
      return;
    }

    const updatedList = projects.filter(
      (item) => item !== form.project
    );

    setProjects(updatedList);

    setForm((prev) => ({ ...prev, project: "" }));
  };


const [machines, setMachines] = useState(data.Machines);
const [newMachine, setNewMachine] = useState("");

const addMachine = () => {
  if (!verifyHRAccess()) return;

  const value = newMachine.trim();

  if (value === "") {
    alert("Enter machine name");
    return;
  }

  if (machines.includes(value)) {
    alert("Machine already exists");
    return;
  }

  setMachines([...machines, value]);
  setNewMachine("");
};

const deleteMachine = () => {
  if (!verifyHRAccess()) return;

  if (!form.machine) {
    alert("Select a machine to remove");
    return;
  }

  setMachines(machines.filter((m) => m !== form.machine));

  setForm({
    ...form,
    machine: "",
  });
};



const [areas, setAreas] = useState(data.Area);
const [newArea, setNewArea] = useState("");
const [selectedArea, setSelectedArea] = useState("");

const addArea = () => {
  if (!verifyHRAccess()) return;

  const value = newArea.trim();

  if (!value) {
    alert("Enter an Area");
    return;
  }

  if (areas.includes(value)) {
    alert("Area already exists");
    return;
  }

  setAreas([...areas, value]);
  setNewArea("");
};


const removeArea = () => {
  if (!verifyHRAccess()) return;

  if (!selectedArea) {
    alert("Select an Area to remove");
    return;
  }

  setAreas(areas.filter((a) => a !== selectedArea));

  if (form.area === selectedArea) {
    setForm({
      ...form,
      area: "",
    });
  }

  setSelectedArea("");
};




const [toolsConsumed, setToolsConsumed] = useState(data.ToolsConsumed);
const [newToolConsumed, setNewToolConsumed] = useState("");
const [selectedToolConsumed, setSelectedToolConsumed] = useState("");

const addToolConsumed = () => {
  if (!verifyHRAccess()) return;

  const value = newToolConsumed.trim();

  if (!value) {
    alert("Enter Quantity");
    return;
  }

  if (toolsConsumed.includes(value)) {
    alert("Quantity already exists");
    return;
  }

  setToolsConsumed([...toolsConsumed, value]);
  setNewToolConsumed("");
};

const removeToolConsumed = () => {
  if (!verifyHRAccess()) return;

  if (!selectedToolConsumed) {
    alert("Select Quantity to remove");
    return;
  }

  setToolsConsumed(
    toolsConsumed.filter((item) => item !== selectedToolConsumed)
  );

  if (form.toolsConsumed === selectedToolConsumed) {
    setForm({
      ...form,
      toolsConsumed: "",
    });
  }

  setSelectedToolConsumed("");
};




// SELECT WORK
const [works, setWorks] = useState(data.ProjectWorks);
const [newWork, setNewWork] = useState("");

const addWork = () => {
  if (!verifyHRAccess()) return;

  const value = newWork.trim();

  if (!value) {
    alert("Enter work");
    return;
  }

  if (works.includes(value)) {
    alert("Work already exists");
    return;
  }

  setWorks([...works, value]);
  setNewWork("");
};

const removeWork = () => {
  if (!verifyHRAccess()) return;

  if (!form.work) {
    alert("Select a work to remove");
    return;
  }

  setWorks(works.filter((w) => w !== form.work));

  setForm((prev) => ({
    ...prev,
    work: "",
  }));
};



// SELECT SHIFT
const [shifts, setShifts] = useState(data.Shifts);
const [newShift, setNewShift] = useState("");

const addShift = () => {
  if (!verifyHRAccess()) return;

  const value = newShift.trim();

  if (!value) {
    alert("Enter shift");
    return;
  }

  if (shifts.includes(value)) {
    alert("Shift already exists");
    return;
  }

  setShifts([...shifts, value]);
  setNewShift("");
};

const removeShift = () => {
  if (!verifyHRAccess()) return;

  if (!form.shift_name) {
    alert("Select a shift to remove");
    return;
  }

  setShifts(shifts.filter((s) => s !== form.shift_name));

  setForm((prev) => ({
    ...prev,
    shift_name: "",
  }));
};



// CONSUMED ITEM
const [consumedItems, setConsumedItems] = useState(data.Consumed);
const [newConsumedItem, setNewConsumedItem] = useState("");

const addConsumedItem = () => {
  if (!verifyHRAccess()) return;

  const value = newConsumedItem.trim();

  if (!value) {
    alert("Enter consumed item");
    return;
  }

  if (consumedItems.includes(value)) {
    alert("Consumed item already exists");
    return;
  }

  setConsumedItems([...consumedItems, value]);
  setNewConsumedItem("");
};

const removeConsumedItem = () => {
  if (!verifyHRAccess()) return;

  if (!form.consumed) {
    alert("Select a consumed item to remove");
    return;
  }

  setConsumedItems(consumedItems.filter((c) => c !== form.consumed));

  setForm((prev) => ({
    ...prev,
    consumed: "",
  }));
};



// WORK STATUS
const [workStatuses, setWorkStatuses] = useState(data.WorkStatus);
const [newWorkStatus, setNewWorkStatus] = useState("");

const addWorkStatus = () => {
  if (!verifyHRAccess()) return;

  const value = newWorkStatus.trim();

  if (!value) {
    alert("Enter work status");
    return;
  }

  if (workStatuses.includes(value)) {
    alert("Work status already exists");
    return;
  }

  setWorkStatuses([...workStatuses, value]);
  setNewWorkStatus("");
};

const removeWorkStatus = () => {
  if (!verifyHRAccess()) return;

  if (!form.status) {
    alert("Select a work status to remove");
    return;
  }

  setWorkStatuses(workStatuses.filter((s) => s !== form.status));

  setForm((prev) => ({
    ...prev,
    status: "",
  }));
};



// DESIGN / OTHER ACTIVITIES
const [designActivities, setDesignActivities] = useState(
  data.DesignActivities
);
const [newDesignActivity, setNewDesignActivity] = useState("");

const addDesignActivity = () => {
  if (!verifyHRAccess()) return;

  const value = newDesignActivity.trim();

  if (!value) {
    alert("Enter activity");
    return;
  }

  if (designActivities.includes(value)) {
    alert("Activity already exists");
    return;
  }

  setDesignActivities([...designActivities, value]);
  setNewDesignActivity("");
};

const removeDesignActivity = () => {
  if (!verifyHRAccess()) return;

  if (!form.designActivity) {
    alert("Select an activity to remove");
    return;
  }

  setDesignActivities(
    designActivities.filter((d) => d !== form.designActivity)
  );

  setForm((prev) => ({
    ...prev,
    designActivity: "",
  }));
};



// WFH NAMES
const [wfhNames, setWfhNames] = useState(data.WFHNames);
const [newWfhName, setNewWfhName] = useState("");

const addWfhName = () => {
  if (!verifyHRAccess()) return;

  const value = newWfhName.trim();

  if (!value) {
    alert("Enter WFH name");
    return;
  }

  if (wfhNames.includes(value)) {
    alert("WFH name already exists");
    return;
  }

  setWfhNames([...wfhNames, value]);
  setNewWfhName("");
};

const removeWfhName = () => {
  if (!verifyHRAccess()) return;

  if (!form.wfhName) {
    alert("Select a WFH name to remove");
    return;
  }

  setWfhNames(wfhNames.filter((w) => w !== form.wfhName));

  setForm((prev) => ({
    ...prev,
    wfhName: "",
  }));
};


// ---- SHARED (JSONBIN) SYNC FOR ALL DROPDOWN LISTS ----
// hasLoadedFromBin guards the save effect below from firing (and
// overwriting the shared bin with this browser's defaults) before the
// very first fetch from JSONBin has actually completed.
const hasLoadedFromBin = useRef(false);

// On mount: load every dropdown list from the shared JSONBin bin, then
// keep polling so Add/Remove changes made by other users show up here
// automatically (without needing a manual page refresh).
useEffect(() => {
  let isMounted = true;

  const loadFromBin = async () => {
    const remote = await fetchAllListsFromBin();

    if (!isMounted || !remote) return;

    if (Array.isArray(remote.persons)) setPersons(remote.persons);
    if (Array.isArray(remote.projects)) setProjects(remote.projects);
    if (Array.isArray(remote.machines)) setMachines(remote.machines);
    if (Array.isArray(remote.areas)) setAreas(remote.areas);
    if (Array.isArray(remote.toolsConsumed))
      setToolsConsumed(remote.toolsConsumed);
    if (Array.isArray(remote.works)) setWorks(remote.works);
    if (Array.isArray(remote.shifts)) setShifts(remote.shifts);
    if (Array.isArray(remote.consumedItems))
      setConsumedItems(remote.consumedItems);
    if (Array.isArray(remote.workStatuses))
      setWorkStatuses(remote.workStatuses);
    if (Array.isArray(remote.designActivities))
      setDesignActivities(remote.designActivities);
    if (Array.isArray(remote.wfhNames)) setWfhNames(remote.wfhNames);

    hasLoadedFromBin.current = true;
  };

  loadFromBin();

  const pollId = setInterval(loadFromBin, SYNC_POLL_INTERVAL);

  return () => {
    isMounted = false;
    clearInterval(pollId);
  };
}, []);

// Whenever ANY dropdown list changes locally (someone hit Add or Remove),
// push the full set of lists back to JSONBin in one request so every
// other user picks it up on their next load/poll.
useEffect(() => {
  if (!hasLoadedFromBin.current) return;

  saveAllListsToBin({
    persons,
    projects,
    machines,
    areas,
    toolsConsumed,
    works,
    shifts,
    consumedItems,
    workStatuses,
    designActivities,
    wfhNames,
  });
}, [
  persons,
  projects,
  machines,
  areas,
  toolsConsumed,
  works,
  shifts,
  consumedItems,
  workStatuses,
  designActivities,
  wfhNames,
]);




  // ---- SEARCH FILTERS FOR ALL DROPDOWNS ----
  const [personSearch, setPersonSearch] = useState("");
  const [projectSearch, setProjectSearch] = useState("");
  const [workSearch, setWorkSearch] = useState("");
  const [machineSearch, setMachineSearch] = useState("");
  const [shiftSearch, setShiftSearch] = useState("");
  const [areaSearch, setAreaSearch] = useState("");
  const [consumedSearch, setConsumedSearch] = useState("");
  const [toolsConsumedSearch, setToolsConsumedSearch] = useState("");
  const [workStatusSearch, setWorkStatusSearch] = useState("");
  const [designActivitySearch, setDesignActivitySearch] = useState("");
  const [wfhSearch, setWfhSearch] = useState("");

  const filteredPersons = persons.filter((p) =>
    p.toLowerCase().includes(personSearch.toLowerCase())
  );
  const filteredProjects = projects.filter((p) =>
    p.toLowerCase().includes(projectSearch.toLowerCase())
  );
  const filteredWorks = works.filter((w) =>
    w.toLowerCase().includes(workSearch.toLowerCase())
  );
  const filteredMachines = machines.filter((m) =>
    m.toLowerCase().includes(machineSearch.toLowerCase())
  );
  const filteredShifts = shifts.filter((s) =>
    s.toLowerCase().includes(shiftSearch.toLowerCase())
  );
  const filteredAreas = areas.filter((a) =>
    a.toLowerCase().includes(areaSearch.toLowerCase())
  );
  const filteredConsumedItems = consumedItems.filter((c) =>
    c.toLowerCase().includes(consumedSearch.toLowerCase())
  );
  const filteredToolsConsumed = toolsConsumed.filter((t) =>
    t.toLowerCase().includes(toolsConsumedSearch.toLowerCase())
  );
  const filteredWorkStatuses = workStatuses.filter((s) =>
    s.toLowerCase().includes(workStatusSearch.toLowerCase())
  );
  const filteredDesignActivities = designActivities.filter((d) =>
    d.toLowerCase().includes(designActivitySearch.toLowerCase())
  );
  const filteredWfhNames = wfhNames.filter((w) =>
    w.toLowerCase().includes(wfhSearch.toLowerCase())
  );

  // Small search box style shared by every dropdown filter
  const searchBoxStyle = {
    width: "180px",
    height: "28px",
    fontSize: "12px",
    padding: "5px",
    borderRadius: "6px",
    border: "1px solid rgba(255,255,255,0.4)",
    background: "rgba(255,255,255,0.9)",
    color: "#000",
  };

  // BIGGER INPUTS
  const inputStyle = {
    padding: "24px",
    borderRadius: "20px",
    border: "1px solid rgba(255,255,255,0.18)",
    width: "100%",
    outline: "none",
    fontSize: "24px",
    background: "rgba(255,255,255,0.12)",
    boxSizing: "border-box",
    minHeight: "88px",
    color: "#ffffff",
    fontWeight: "700",
    transition: "0.3s",
    backdropFilter: "blur(12px)",
    boxShadow: "0 8px 20px rgba(0,0,0,0.25)",
  };

  const labelStyle = {
    marginBottom: "12px",
    fontWeight: "800",
    color: "#ffffff",
    fontSize: "24px",
  };

  return (
    <div
      onMouseMove={handleMove}
      onTouchMove={handleMove}
      style={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
        background:
          "linear-gradient(135deg,#03045e,#240046,#5a189a,#7209b7)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* CURSOR GLOW */}
      <div
        style={{
          position: "fixed",
          left: pointer.x - 100,
          top: pointer.y - 100,
          width: "200px",
          height: "200px",
          borderRadius: "50%",
          background: "rgba(255,255,255,0.12)",
          filter: "blur(60px)",
          pointerEvents: "none",
          zIndex: 1,
        }}
      />

      {/* CURSOR POINTER */}
      <div
        style={{
          position: "fixed",
          top: pointer.y - 10,
          left: pointer.x - 10,
          width: "20px",
          height: "20px",
          borderRadius: "50%",
          background: "#ffea00",
          boxShadow: "0 0 25px #ffea00",
          pointerEvents: "none",
          zIndex: 99999,
        }}
      />

      {/* FLOATING MACHINE ICONS */}
      {machineImages.map((img, index) => (
        <img
          key={index}
          src={img}
          alt=""
          style={{
            position: "absolute",
            width: index % 2 === 0 ? "260px" : "220px",
            opacity: "0.12",
            animation: `float ${8 + index}s infinite`,
            filter: "drop-shadow(0 0 20px rgba(255,234,0,0.5))",

            top: index === 0 ? "5%" : "75%",
            left: index === 0 ? "5%" : "7%",
          }}
        />
      ))}

      {/* FACTORY BACKGROUND */}
      <img
        src={machinePics[1]}
        alt=""
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          objectFit: "cover",
          opacity: "0.10",
        }}
      />

      {/* AI ASSISTANT */}
      <div
        className="assistant-box"
        style={{
          position: "fixed",
          right: "15px",
          bottom: "15px",
          zIndex: 999,
          display: "flex",
          alignItems: "center",
          gap: "14px",
          background: "rgba(255,255,255,0.15)",
          padding: "15px 18px",
          borderRadius: "22px",
          backdropFilter: "blur(14px)",
          boxShadow: "0 10px 35px rgba(255,234,0,0.35)",
          border: "1px solid rgba(255,234,0,0.25)",
          animation: "floatBot 4s infinite",
          maxWidth: "350px",
        }}
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/4712/4712035.png"
          alt=""
          style={{
            width: "65px",
            height: "65px",
          }}
        />

        <div>
          <div
            style={{
              color: "#ffffff",
              fontWeight: "900",
              fontSize: "18px",
            }}
          >
            COSMOS AI ASSISTANT
          </div>

          <div
            style={{
              color: "#f1f1f1",
              marginTop: "6px",
              fontSize: "15px",
              lineHeight: "22px",
              fontWeight: "600",
            }}
          >
            {botMessage}
          </div>
        </div>
      </div>

      {/* MAIN CARD */}
      <div
        className="main-card"
        style={{
          width: "100%",
          maxWidth: "1500px",
          padding: "35px",
          borderRadius: "30px",
          background: "rgba(255,255,255,0.10)",
          backdropFilter: "blur(20px)",
          border: "1px solid rgba(255,255,255,0.15)",
          boxShadow: "0 20px 50px rgba(0,0,0,0.4)",
          position: "relative",
          zIndex: 2,
          boxSizing: "border-box",
        }}
      >
        {/* TOP BAR */}
        <div
          style={{
            width: "100%",
            padding: "18px 24px",
            marginBottom: "20px",
            borderRadius: "18px",
            background: "rgba(255,255,255,0.10)",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            boxSizing: "border-box",
            border: "1px solid rgba(255,255,255,0.12)",
            flexWrap: "wrap",
            gap: "10px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              color: "#ffffff",
              fontWeight: "700",
              fontSize: "22px",
            }}
          >
            <div
              style={{
                width: "12px",
                height: "12px",
                borderRadius: "50%",
                background: "#ffea00",
                boxShadow: "0 0 15px #ffea00",
              }}
            />

            Production System Active
          </div>

          <div
            style={{
              color: "#ffffff",
              fontWeight: "800",
              letterSpacing: "1px",
              fontSize: "28px",
            }}
          >
            Work Entry Form
          </div>
        </div>

        {/* BANNER */}
        <div
          className="banner"
          style={{
            width: "100%",
            height: "320px",
            borderRadius: "28px",
            marginBottom: "30px",
            overflow: "hidden",
            position: "relative",
          }}
        >
          <img
            src={machinePics[0]}
            alt=""
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />

          <div
            style={{
              position: "absolute",
              inset: 0,
              background:
                "linear-gradient(to right, rgba(0,0,0,0.7), rgba(0,0,0,0.2))",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              textAlign: "center",
              padding: "20px",
            }}
          >
            <div
              style={{
                color: "#ffffff",
                fontSize: "clamp(32px, 6vw, 64px)",
                fontWeight: "900",
                letterSpacing: "2px",
              }}
            >
              COSMOS AUTOMATION
            </div>

            <div
              style={{
                marginTop: "12px",
                color: "#f8f9fa",
                fontSize: "clamp(18px, 3vw, 28px)",
                fontWeight: "600",
              }}
            >
              Smart Manufacturing | Smart Workflow | Smart Tracking
            </div>
          </div>
        </div>

        {/* HEADER */}
        <div
          style={{
            textAlign: "center",
            marginBottom: "35px",
          }}
        >
          <h2
            style={{
              margin: "0",
              color: "#ffffff",
              fontSize: "clamp(30px, 5vw, 48px)",
              fontWeight: "900",
            }}
          >
            Work Entry Form
          </h2>
        </div>

        {/* FORM */}
        <div
          className="form-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2,1fr)",
            gap: "24px",
          }}
        >

{/* SELECT PERSON (input + add/remove stacked below) */}
<div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
  <input
    type="text"
    value={personSearch}
    onChange={(e) => setPersonSearch(e.target.value)}
    placeholder="Search Person..."
    style={searchBoxStyle}
  />

  <select
    name="person"
    value={form.person}
    onChange={(e) => {
      handleChange(e);
      setSelectedPerson(e.target.value);
    }}
    style={inputStyle}
  >
    <option value="">Select Person </option>

    {filteredPersons.map((p) => (
      <option key={p}>{p}</option>
    ))}
  </select>

  <input
    type="text"
    value={newPerson}
    onChange={(e) => setNewPerson(e.target.value)}
    placeholder="Enter Person Name"
    style={{
      width: "180px",
      height: "30px",
      fontSize: "12px",
      padding: "5px",
    }}
  />

  <div
    style={{
      display: "flex",
      gap: "10px",
      alignItems: "center",
    }}
  >
    <button
      type="button"
      onClick={handleAddPerson}
      style={{
        width: "70px",
        height: "30px",
        fontSize: "12px",
        cursor: "pointer",
      }}
    >
      Add
    </button>

    <button
      type="button"
      onClick={handleDeletePerson}
      style={{
        width: "70px",
        height: "30px",
        fontSize: "12px",
        cursor: "pointer",
      }}
    >
      Remove
    </button>
  </div>
</div>

{/* SELECT PROJECT (input + add/remove stacked below) */}
<div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
  <input
    type="text"
    value={projectSearch}
    onChange={(e) => setProjectSearch(e.target.value)}
    placeholder="Search Project..."
    style={searchBoxStyle}
  />

  <select
    name="project"
    value={form.project}
    onChange={handleChange}
    style={inputStyle}
  >
    <option value="">Select Project</option>

    {filteredProjects.map((p) => (
      <option key={p} value={p}>
        {p}
      </option>
    ))}
  </select>

  <input
    type="text"
    value={newProject}
    onChange={(e) => setNewProject(e.target.value)}
    placeholder="Enter Project"
    style={{
      width: "180px",
      height: "30px",
      fontSize: "12px",
      padding: "5px",
    }}
  />

  <div
    style={{
      display: "flex",
      gap: "10px",
      alignItems: "center",
    }}
  >
    <button
      type="button"
      onClick={addProject}
      style={{
        width: "70px",
        height: "30px",
        fontSize: "12px",
        cursor: "pointer",
      }}
    >
      Add
    </button>

    <button
      type="button"
      onClick={deleteProject}
      style={{
        width: "70px",
        height: "30px",
        fontSize: "12px",
        cursor: "pointer",
      }}
    >
      Remove
    </button>
  </div>
</div>


{/* SELECT WORK (input + add/remove stacked below) */}
<div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
  <input
    type="text"
    value={workSearch}
    onChange={(e) => setWorkSearch(e.target.value)}
    placeholder="Search Work..."
    style={searchBoxStyle}
  />

  <select
    name="work"
    value={form.work}
    onChange={handleChange}
    style={inputStyle}
  >
    <option value="">Select Work </option>

    {filteredWorks.map((w) => (
      <option key={w}>{w}</option>
    ))}
  </select>

  <input
    type="text"
    value={newWork}
    onChange={(e) => setNewWork(e.target.value)}
    placeholder="Enter Work"
    style={{
      width: "180px",
      height: "30px",
      fontSize: "12px",
      padding: "5px",
    }}
  />

  <div
    style={{
      display: "flex",
      gap: "10px",
      alignItems: "center",
    }}
  >
    <button
      type="button"
      onClick={addWork}
      style={{
        width: "70px",
        height: "30px",
        fontSize: "12px",
        cursor: "pointer",
      }}
    >
      Add
    </button>

    <button
      type="button"
      onClick={removeWork}
      style={{
        width: "70px",
        height: "30px",
        fontSize: "12px",
        cursor: "pointer",
      }}
    >
      Remove
    </button>
  </div>
</div>


{/* SELECT MACHINE (input + add/remove stacked below, buttons in one row) */}
<div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
  <input
    type="text"
    value={machineSearch}
    onChange={(e) => setMachineSearch(e.target.value)}
    placeholder="Search Machine..."
    style={searchBoxStyle}
  />

  <select
    name="machine"
    value={form.machine}
    onChange={handleChange}
    style={inputStyle}
  >
    <option value="">Select Machine</option>

    {filteredMachines.map((m) => (
      <option key={m} value={m}>
        {m}
      </option>
    ))}
  </select>

  <input
    type="text"
    value={newMachine}
    onChange={(e) => setNewMachine(e.target.value)}
    placeholder="Enter Machine"
    style={{
      width: "180px",
      height: "30px",
      fontSize: "12px",
      padding: "5px",
    }}
  />

  <div
    style={{
      display: "flex",
      gap: "10px",
      alignItems: "center",
    }}
  >
    <button
      type="button"
      onClick={addMachine}
      style={{
        width: "70px",
        height: "30px",
        fontSize: "12px",
        cursor: "pointer",
      }}
    >
      ADD
    </button>

    <button
      type="button"
      onClick={deleteMachine}
      style={{
        width: "70px",
        height: "30px",
        fontSize: "12px",
        cursor: "pointer",
      }}
    >
      REMOVE
    </button>
  </div>
</div>

{/* SELECT SHIFT (input + add/remove stacked below) */}
<div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
  <input
    type="text"
    value={shiftSearch}
    onChange={(e) => setShiftSearch(e.target.value)}
    placeholder="Search Shift..."
    style={searchBoxStyle}
  />

  <select
    name="shift_name"
    value={form.shift_name}
    onChange={handleChange}
    style={inputStyle}
  >
    <option value="">Select Shift</option>

    {filteredShifts.map((s) => (
      <option key={s}>{s}</option>
    ))}
  </select>

  <input
    type="text"
    value={newShift}
    onChange={(e) => setNewShift(e.target.value)}
    placeholder="Enter Shift"
    style={{
      width: "180px",
      height: "30px",
      fontSize: "12px",
      padding: "5px",
    }}
  />

  <div
    style={{
      display: "flex",
      gap: "10px",
      alignItems: "center",
    }}
  >
    <button
      type="button"
      onClick={addShift}
      style={{
        width: "70px",
        height: "30px",
        fontSize: "12px",
        cursor: "pointer",
      }}
    >
      Add
    </button>

    <button
      type="button"
      onClick={removeShift}
      style={{
        width: "70px",
        height: "30px",
        fontSize: "12px",
        cursor: "pointer",
      }}
    >
      Remove
    </button>
  </div>
</div>

{/* SELECT AREA (input + add/remove stacked below, buttons in one row) */}
<div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
  <input
    type="text"
    value={areaSearch}
    onChange={(e) => setAreaSearch(e.target.value)}
    placeholder="Search Area..."
    style={searchBoxStyle}
  />

  <select
    name="area"
    value={form.area}
    onChange={(e) => {
      handleChange(e);
      setSelectedArea(e.target.value);
    }}
    style={inputStyle}
  >
    <option value="">Select Area</option>

    {filteredAreas.map((a) => (
      <option key={a} value={a}>
        {a}
      </option>
    ))}
  </select>

  <input
    type="text"
    value={newArea}
    onChange={(e) => setNewArea(e.target.value)}
    placeholder="Enter New Area"
    style={{
      width: "180px",
      height: "30px",
      fontSize: "12px",
      padding: "5px",
    }}
  />

  <div
    style={{
      display: "flex",
      gap: "10px",
      alignItems: "center",
    }}
  >
    <button
      type="button"
      onClick={addArea}
      style={{
        width: "80px",
        height: "35px",
        cursor: "pointer",
        fontWeight: "bold",
      }}
    >
      ADD
    </button>

    <button
      type="button"
      onClick={removeArea}
      style={{
        width: "90px",
        height: "35px",
        cursor: "pointer",
        fontWeight: "bold",
        background: "#fff",
        color: "#000",
        border: "none",
        borderRadius: "4px",
      }}
    >
      REMOVE
    </button>
  </div>
</div>



{/* CONSUMED ITEM (input + add/remove stacked below) */}
<div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
  <input
    type="text"
    value={consumedSearch}
    onChange={(e) => setConsumedSearch(e.target.value)}
    placeholder="Search Consumed Item..."
    style={searchBoxStyle}
  />

  <select
    name="consumed"
    value={form.consumed}
    onChange={handleChange}
    style={inputStyle}
  >
    <option value="">Consumed Item</option>

    {filteredConsumedItems.map((c) => (
      <option key={c}>{c}</option>
    ))}
  </select>

  <input
    type="text"
    value={newConsumedItem}
    onChange={(e) => setNewConsumedItem(e.target.value)}
    placeholder="Enter Consumed Item"
    style={{
      width: "180px",
      height: "30px",
      fontSize: "12px",
      padding: "5px",
    }}
  />

  <div
    style={{
      display: "flex",
      gap: "10px",
      alignItems: "center",
    }}
  >
    <button
      type="button"
      onClick={addConsumedItem}
      style={{
        width: "70px",
        height: "30px",
        fontSize: "12px",
        cursor: "pointer",
      }}
    >
      Add
    </button>

    <button
      type="button"
      onClick={removeConsumedItem}
      style={{
        width: "70px",
        height: "30px",
        fontSize: "12px",
        cursor: "pointer",
      }}
    >
      Remove
    </button>
  </div>
</div>

{/* CONSUMED ITEM QUANTITY (input + add/remove stacked below) */}
<div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
  <input
    type="text"
    value={toolsConsumedSearch}
    onChange={(e) => setToolsConsumedSearch(e.target.value)}
    placeholder="Search Quantity..."
    style={searchBoxStyle}
  />

  <select
    name="toolsConsumed"
    value={form.toolsConsumed}
    onChange={(e) => {
      handleChange(e);
      setSelectedToolConsumed(e.target.value);
    }}
    style={inputStyle}
  >
    <option value="">Consumed Item Quantity</option>

    {filteredToolsConsumed.map((t) => (
      <option key={t} value={t}>
        {t}
      </option>
    ))}
  </select>

  <input
    type="text"
    value={newToolConsumed}
    onChange={(e) => setNewToolConsumed(e.target.value)}
    placeholder="Enter Quantity"
    style={{
      width: "180px",
      height: "30px",
      fontSize: "12px",
      padding: "5px",
    }}
  />

  <div
    style={{
      display: "flex",
      gap: "10px",
      alignItems: "center",
    }}
  >
    <button
      type="button"
      onClick={addToolConsumed}
      style={{
        width: "70px",
        height: "30px",
        fontSize: "12px",
        cursor: "pointer",
      }}
    >
      Add
    </button>

    <button
      type="button"
      onClick={removeToolConsumed}
      style={{
        width: "70px",
        height: "30px",
        fontSize: "12px",
        cursor: "pointer",
      }}
    >
      Remove
    </button>
  </div>
</div>

{/* SELECT WORK STATUS (input + add/remove stacked below) */}
<div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
  <input
    type="text"
    value={workStatusSearch}
    onChange={(e) => setWorkStatusSearch(e.target.value)}
    placeholder="Search Status..."
    style={searchBoxStyle}
  />

  <select
    name="status"
    value={form.status}
    onChange={handleChange}
    style={inputStyle}
  >
    <option value="">Select Work Status</option>

    {filteredWorkStatuses.map((s) => (
      <option key={s}>{s}</option>
    ))}
  </select>

  <input
    type="text"
    value={newWorkStatus}
    onChange={(e) => setNewWorkStatus(e.target.value)}
    placeholder="Enter Work Status"
    style={{
      width: "180px",
      height: "30px",
      fontSize: "12px",
      padding: "5px",
    }}
  />

  <div
    style={{
      display: "flex",
      gap: "10px",
      alignItems: "center",
    }}
  >
    <button
      type="button"
      onClick={addWorkStatus}
      style={{
        width: "70px",
        height: "30px",
        fontSize: "12px",
        cursor: "pointer",
      }}
    >
      Add
    </button>

    <button
      type="button"
      onClick={removeWorkStatus}
      style={{
        width: "70px",
        height: "30px",
        fontSize: "12px",
        cursor: "pointer",
      }}
    >
      Remove
    </button>
  </div>
</div>

          <input
            type="text"
            name="workDescription"
            placeholder="Enter Detailed Work Description"
            value={form.workDescription}
            onChange={handleChange}
            style={inputStyle}
          />

          <div>
            <div style={labelStyle}>Start Time</div>

            <input
              type="time"
              name="startTime"
              value={form.startTime}
              onChange={handleChange}
              style={inputStyle}
            />
          </div>

          <div>
            <div style={labelStyle}>End Time</div>

            <input
              type="time"
              name="endTime"
              value={form.endTime}
              onChange={handleChange}
              style={inputStyle}
            />
          </div>
          
{/* ACTIVITIES (input + add/remove stacked below) */}
<div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
  <input
    type="text"
    value={designActivitySearch}
    onChange={(e) => setDesignActivitySearch(e.target.value)}
    placeholder="Search Activity..."
    style={searchBoxStyle}
  />

  <select
    name="designActivity"
    value={form.designActivity}
    onChange={handleChange}
    style={inputStyle}
  >
    <option value="">Activities</option>

    {filteredDesignActivities.map((d) => (
      <option key={d}>{d}</option>
    ))}
  </select>

  <input
    type="text"
    value={newDesignActivity}
    onChange={(e) => setNewDesignActivity(e.target.value)}
    placeholder="Enter Activity"
    style={{
      width: "180px",
      height: "30px",
      fontSize: "12px",
      padding: "5px",
    }}
  />

  <div
    style={{
      display: "flex",
      gap: "10px",
      alignItems: "center",
    }}
  >
    <button
      type="button"
      onClick={addDesignActivity}
      style={{
        width: "70px",
        height: "30px",
        fontSize: "12px",
        cursor: "pointer",
      }}
    >
      Add
    </button>

    <button
      type="button"
      onClick={removeDesignActivity}
      style={{
        width: "70px",
        height: "30px",
        fontSize: "12px",
        cursor: "pointer",
      }}
    >
      Remove
    </button>
  </div>
</div>

          <input
            type="number"
            name="quantity"
            placeholder="Quantity"
            value={form.quantity}
            onChange={handleChange}
            style={inputStyle}
          />

          <input
            type="number"
            name="rejection"
            placeholder="Rejection"
            value={form.rejection}
            onChange={handleChange}
            style={inputStyle}
          />

{/* WFH NAMES (input + add/remove stacked below) */}
<div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
  <input
    type="text"
    value={wfhSearch}
    onChange={(e) => setWfhSearch(e.target.value)}
    placeholder="Search WFH Name..."
    style={searchBoxStyle}
  />

  <select
    name="wfhName"
    value={form.wfhName}
    onChange={handleChange}
    style={inputStyle}
  >
    <option value="">WFH Names</option>

    {filteredWfhNames.map((w) => (
      <option key={w}>{w}</option>
    ))}
  </select>

  <input
    type="text"
    value={newWfhName}
    onChange={(e) => setNewWfhName(e.target.value)}
    placeholder="Enter WFH Name"
    style={{
      width: "180px",
      height: "30px",
      fontSize: "12px",
      padding: "5px",
    }}
  />

  <div
    style={{
      display: "flex",
      gap: "10px",
      alignItems: "center",
    }}
  >
    <button
      type="button"
      onClick={addWfhName}
      style={{
        width: "70px",
        height: "30px",
        fontSize: "12px",
        cursor: "pointer",
      }}
    >
      Add
    </button>

    <button
      type="button"
      onClick={removeWfhName}
      style={{
        width: "70px",
        height: "30px",
        fontSize: "12px",
        cursor: "pointer",
      }}
    >
      Remove
    </button>
  </div>
</div>

        </div>

        {/* REMARKS */}
        <div style={{ marginTop: "25px" }}>
          <div style={labelStyle}>Remarks</div>

          <textarea
            name="remarks"
            placeholder="Enter Complete Remarks Here"
            value={form.remarks}
            onChange={handleChange}
            rows="5"
            style={{
              ...inputStyle,
              resize: "none",
              minHeight: "180px",
            }}
          />
        </div>




        <div
  style={{
    marginTop: "30px",
    padding: "20px",
    borderRadius: "15px",
    background: "rgba(255,255,255,0.08)",
  }}
>
  
</div>

  













        {/* MACHINE ICONS */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "25px",
            flexWrap: "wrap",
            marginTop: "30px",
          }}
        >
          {machineImages.map((img, index) => (
            <img
              key={index}
              src={img}
              alt=""
              style={{
                width: "80px",
                animation: "float 6s infinite",
                filter: "drop-shadow(0 0 12px rgba(255,234,0,0.6))",
              }}
            />
          ))}
        </div>

        {/* SUBMIT BUTTON */}
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <button
            onClick={handleSubmit}
            className="submit-btn"
            style={{
              width: "40%",
              minWidth: "260px",
              marginTop: "35px",
              padding: "24px",
              border: "none",
              borderRadius: "18px",
              background:
                "linear-gradient(135deg,#7b2cbf,#9d4edd,#c77dff)",
              color: "#fff",
              fontSize: "30px",
              fontWeight: "800",
              cursor: "pointer",
              transition: "0.3s",
              boxShadow: "0 12px 28px rgba(255,234,0,0.35)",
            }}
          >
            Submit
          </button>
        </div>

    <div style={{ padding: "20px" }}>
     
      <button onClick={handleDownloadClick}>Download CSV</button>
    </div>

    



      </div>

      {/* STYLES */}
      <style>
        {`
          *{
            box-sizing:border-box;
          }

          @keyframes float {
            0% { transform: translateY(0px); }
            50% { transform: translateY(-18px); }
            100% { transform: translateY(0px); }
          }

          @keyframes floatBot {
            0% { transform: translateY(0px); }
            50% { transform: translateY(-10px); }
            100% { transform: translateY(0px); }
          }

          select option {
            color: black;
            background: white;
            font-size: 20px;
          }

          input::placeholder,
          textarea::placeholder {
            color: rgba(255,255,255,0.80);
            font-size: 20px;
            font-weight: 600;
          }

          input:focus,
          select:focus,
          textarea:focus {
            border: 1px solid #ffea00;
            box-shadow: 0 0 20px rgba(255,234,0,0.9);
          }

          button:hover {
            transform: scale(1.02);
            box-shadow: 0 0 35px rgba(255,234,0,1);
            background: linear-gradient(135deg,#ffd60a,#ffea00,#ffee32);
            color: #000;
          }

          body {
            margin: 0;
            overflow-x: hidden;
            font-family: Arial, sans-serif;
            background: #000;
            cursor: default;
          }

          @media screen and (max-width: 1200px) {

            .main-card{
              padding:25px !important;
            }

            .form-grid {
              grid-template-columns: 1fr 1fr !important;
            }
          }

          @media screen and (max-width: 900px) {

            .form-grid {
              grid-template-columns: 1fr !important;
            }

            .form-grid select,
            .form-grid input,
            textarea {
              font-size: 20px !important;
              min-height: 82px !important;
              padding: 22px !important;
            }

            .submit-btn{
              width:100% !important;
              font-size:26px !important;
            }

            .assistant-box{
              transform:scale(0.9);
              right:5px !important;
              bottom:5px !important;
            }
          }

          @media screen and (max-width: 600px) {

            .main-card{
              padding:16px !important;
              border-radius:22px !important;
            }

            .banner{
              height:220px !important;
            }

            .assistant-box{
              display:none !important;
            }

            .form-grid{
              gap:18px !important;
            }

            .form-grid select,
            .form-grid input,
            textarea {
              font-size:18px !important;
              min-height:76px !important;
              padding:20px !important;
            }

            input::placeholder,
            textarea::placeholder {
              font-size: 17px !important;
            }

            .submit-btn{
              width:100% !important;
              min-width:100% !important;
              padding:20px !important;
              font-size:24px !important;
            }
          }
        `}
      </style>
   


    </div>
  );
};

export default ShopFloor;